import React from "react";

// Presentational pill. Removal is owned by the caller (SearchBar), which maps
// each tag to the sidebar filter it represents (searchTags make/model, or the
// multi-select years/versions/engines).
export const FilterTag = ({category, value, onRemove}) => {
    return (
        <span className="filter-tag">
            {value}
            <button className="filter-tag-x" onClick={onRemove} title="Remove filter">✕</button>
    </span>
    );
}
